module.exports = __webpack_public_path__ + "ai.png?e93d423383f4b84044475c03b8b4759c";